export default __webpack_public_path__ + "static/media/event.cb8be882.svg";